import StatusesPage from './StatusesPage';

export default StatusesPage;
